module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1145.43ef2639.png";